import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessBisonBoxExportStatus: 'idle',
    startProcessBisonBoxExportError: undefined as any,
    loadUserParamsProcessBisonBoxExportStatus: 'idle',
    loadUserParamsProcessBisonBoxExportError: undefined as any,

    processBisonBoxExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessBisonBoxExport = createAsyncThunk('processBisonBoxExportSlice/startProcessBisonBoxExport', async ({ processBisonBoxExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessBisonBoxExport/`,
        prepareData(processBisonBoxExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessBisonBoxExportStatus } = getState().processBisonBoxExportSlice
        return startProcessBisonBoxExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessBisonBoxExport = createAsyncThunk('processBisonBoxExportSlice/loadUserParamsProcessBisonBoxExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessBisonBoxExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessBisonBoxExportStatus } = getState().processBisonBoxExportSlice
        return loadUserParamsProcessBisonBoxExportStatus !== 'pending'
    }
})

const ProcessBisonBoxExportSlice = createSlice({
    name: 'processBisonBoxExportSlice',
    initialState,
    reducers: {
        resetstartProcessBisonBoxExport: (state) => {
            state.job = undefined
            state.startProcessBisonBoxExportError = undefined
        },
        resetstartProcessBisonBoxExportError: (state) => {
            state.startProcessBisonBoxExportError = undefined
        },
        resetloadUserParamsProcessBisonBoxExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessBisonBoxExportError = undefined
        },
        resetloadUserParamsProcessBisonBoxExportError: (state) => {
            state.loadUserParamsProcessBisonBoxExportError = undefined
        },
        removeFromProcessBisonBoxExportListById: (state, action) => {
            state.processBisonBoxExportList = state.processBisonBoxExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessBisonBoxExportListByIds: (state, action) => {
            state.processBisonBoxExportList = state.processBisonBoxExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processBisonBoxExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessBisonBoxExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processBisonBoxExportList = []
            state.startProcessBisonBoxExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessBisonBoxExport.pending, (state) => {
            state.startProcessBisonBoxExportStatus = 'pending'
            state.startProcessBisonBoxExportError = undefined
        })
        builder.addCase(startProcessBisonBoxExport.fulfilled, (state, action) => {
            state.startProcessBisonBoxExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessBisonBoxExport.rejected, (state, action) => {
            state.startProcessBisonBoxExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessBisonBoxExportError = action.error.message
            } else {
                state.startProcessBisonBoxExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessBisonBoxExport.pending, (state) => {
            state.loadUserParamsProcessBisonBoxExportStatus = 'pending'
            state.loadUserParamsProcessBisonBoxExportError = undefined
        })
        builder.addCase(loadUserParamsProcessBisonBoxExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessBisonBoxExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessBisonBoxExport.rejected, (state, action) => {
            state.loadUserParamsProcessBisonBoxExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessBisonBoxExportError = action.error.message
            } else {
                state.loadUserParamsProcessBisonBoxExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessBisonBoxExport,
    resetstartProcessBisonBoxExportError,
    resetloadUserParamsProcessBisonBoxExport,
    resetloadUserParamsProcessBisonBoxExportError,
    removeFromProcessBisonBoxExportListById,
    removeFromProcessBisonBoxExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessBisonBoxExportSlice.actions
export default ProcessBisonBoxExportSlice.reducer
